import isFunction from 'lodash/isFunction';
import React from 'react';

import styles from './toggleSwitch.scss';

interface ToggleSwitchProps {
  value: boolean;
  onChange: (...args: unknown[]) => unknown;
  disabled?: boolean;
}

function ToggleSwitch({ id, value, onChange, disabled = false }: ToggleSwitchProps) {
  const toggleSwitch = (event) => {
    const { checked } = event.target;
    if (isFunction(onChange)) {
      onChange(checked);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (isFunction(onChange)) {
        onChange(!value);
      }
    }
  };

  return (
    <label htmlFor={`toggle-switch-${id}`} className={styles['toggle-switch']}>
      <input
        type="checkbox"
        id={`toggle-switch-${id}`}
        checked={value}
        disabled={disabled}
        onChange={toggleSwitch}
        onKeyDown={handleKeyDown}
        aria-checked={value}
        role="switch"
      />
      <span className={styles.switch} />
    </label>
  );
}

export default ToggleSwitch;
